export default __webpack_public_path__ + "static/product-3-123e623ec93888fcfdcd3aa6e4147679.png";